module.exports = __webpack_public_path__ + "static/img/developer.98b37c0e.png";